
const FormInput = ({ label, additionalClasses, ...otherProps }) => {
    return (
        <div className={`${additionalClasses ? additionalClasses : ""}`}>
        {label && (
            <label>{label}</label>
        )}
        <input {...otherProps} className="input is-large" onWheel={(e) => {e.target.blur()}}/>
        </div>
    );
}

export default FormInput;